import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_PARTNER_ACCOUNTS,
  FETCH_PARTNER_ACCOUNTS_ERROR,
  SET_PARTNER_ACCOUNTS,
} from '../../constants';

const fetchPartnerAccounts = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_PARTNER_ACCOUNTS),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/partners?v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_PARTNER_ACCOUNTS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_PARTNER_ACCOUNTS_ERROR,
            error,
          })
        )
      )
    )
  );

export default fetchPartnerAccounts;
